import React from 'react'
import { graphql } from 'gatsby'

import { renderAstWithWidgets } from "@utils"

import FloatingSidebarNav from '@components/FloatingSidebarNav/FloatingSidebarNav'
import SEO from '@components/SEO/SEO'

import CompanyPageHero from './CompanyPageHero/CompanyPageHero.js'

import {
  CompanyPageContentDIV,
  CompanyPageWrapperDIV,
} from './CompanyPage.styles'

export const Head = ({
  data: {
    pageData: {
      frontmatter: {
        meta_description,
        permalink,
        page_title,
      },
    },
  },
}) => (
  <SEO
    description={meta_description}
    permalink={permalink}
    title={`${page_title} - Help Scout`}
  />
)

const CompanyPage = ({
  data: {
    pageData: {
      htmlAst,
      frontmatter: {
        page_title,
        title,
      },
    },
    menuData,
  },
}) => {
  return (
    <>
      <CompanyPageHero />
      <CompanyPageWrapperDIV>
        <FloatingSidebarNav
          activeItemTitle={page_title}
          items={menuData.edges.map(
            ({ node: { frontmatter: { page_title, permalink } } }) => ({
              permalink,
              title: page_title,
            })
          )}
        />
        <div className="content-wrapper">
          <div className="container">
            <CompanyPageContentDIV>
              <h2 className="type--headline-medium-2XL">{title}</h2>
              <div>
                {renderAstWithWidgets(htmlAst)}
              </div>
            </CompanyPageContentDIV>
          </div>
        </div>
      </CompanyPageWrapperDIV>
    </>
  )
}

export const pageQuery = graphql`query CompanyPageQuery($id: String!) {
  pageData: markdownRemark(id: {eq: $id}) {
    htmlAst
    frontmatter {
      meta_description
      page_title
      permalink
      title
    }
  }
  menuData: allMarkdownRemark(
    filter: {fileAbsolutePath: {regex: "/company_pages//"}}
    sort: {frontmatter: {menu_order: ASC}}
  ) {
    edges {
      node {
        id
        frontmatter {
          page_title
          permalink
        }
      }
    }
  }
}`

export default CompanyPage
